const ApprovalsGroupsTabs = ({ usersUrl }) => (
  <div className="width-100">
    <ul className="approvals__tabs ls-none fl mb-25 ml-0">
      <li className="approvals__tab bg-grey-5">
        <a
          className="fl fl-col jc-c width-100 height-100 ff-body fw-600 fs-16 ta-c tc-grey-70"
          href={usersUrl}>
          Active Users
        </a>
      </li>
      <li className="approvals__tab bg-cef-red">
        <a
          className="fl fl-col jc-c width-100 height-100 ff-body fw-400 fs-16 ta-c tc-white"
          href="#">
          Order Approval Groups
        </a>
      </li>
    </ul>
  </div>
);

export default ApprovalsGroupsTabs;
